import { defineStore } from 'pinia'
import { ref, watch } from 'vue'
import { tabBar } from '@/pages.json'
const tabbarList = tabBar.list.map((item) => ({ ...item, path: `/${item.pagePath}` }))

export const useTabbarStore = defineStore(
  'tabbar',
  () => {
    const currIndex = ref<number>(Number(uni.getStorageSync('app-tabbar-index')) || 0)

    const setCurrIndex = (val: number) => {
      currIndex.value = val
      uni.setStorageSync('app-tabbar-index', val)
      uni.switchTab({ url: tabbarList[val].path })
    }

    return {
      currIndex,
      tabbarList,
      setCurrIndex,
    }
  },
  {
    persist: true,
  },
)
